import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Box, Grid, useMediaQuery } from '@mui/material';
import ACSnackbar from '../../components/ACSnackbar';
import { useAccount } from '../../contexts/Account';
import BoardsAndInvitations from './BoardsAndInvitations';
import BoardsAndInvitationsLegacy from './BoardsAndInvitationsLegacy';
import BoardroomHeader from './BoardroomHeader';
import eventBus, { eventBusValues } from '../../eventBus';
import MembershipTile from './MembershipTile';
import Treatment from '../../components/Treatment';
import { featureFlags } from './../../splitSetup';

const Dashboard = () => {
  const { accountDetails, isFreemium, currentUserInfo } = useAccount();
  const isSM = useMediaQuery((theme) => theme.breakpoints.down('sm'));
  const isXS = useMediaQuery((theme) => theme.breakpoints.down('xs'));
  const location = useLocation();
  const currentPath = location.pathname;
  const queryParams = new URLSearchParams(location.search);
  const [successSnackbar, setSuccessSnackbar] = useState(false);
  const [errorSnackbar, setErrorSnackbar] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    let conversationId = queryParams.get('conversationId');
    if (conversationId || currentPath.includes('/messages')) {
      eventBus.dispatch(eventBusValues.triggerConversationDrawerV2, {
        conversationId,
      });
    }
  }, []);

  return (
    <Box
      sx={{
        padding: { xxs: '12px 15px', xs: '30px 30px', sm: '24px 30px' },
        width: '100%',
      }}
    >
      <ACSnackbar
        open={successSnackbar}
        text={successMessage}
        severity="success"
        onClose={() => setSuccessSnackbar(false)}
        autoHideDuration={6000}
        style={{ marginTop: isFreemium ? '50px' : '0px' }}
      />
      <ACSnackbar
        open={errorSnackbar}
        text={errorMessage}
        severity="error"
        onClose={() => setErrorSnackbar(false)}
        autoHideDuration={6000}
        style={{ marginTop: isFreemium ? '50px' : '0px' }}
      />

      <Grid
        container
        spacing={3}
        sx={{
          mb: '24px',
          mt: isXS ? '20px' : '0px',
        }}
      >
        <Grid
          item
          xs={12}
          md={8}
          sx={{
            width: isSM ? '100%' : null,
          }}
        >
          <BoardroomHeader
            setSuccessMessage={setSuccessMessage}
            setSuccessSnackbar={setSuccessSnackbar}
            advisor={accountDetails}
          />
        </Grid>
        <Grid
          item
          xs={12}
          md={4}
          sx={{
            width: isSM ? '100%' : null,
            display: { xxs: 'none', xs: 'block' },
          }}
        >
          <MembershipTile />
        </Grid>
      </Grid>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Treatment
            userId={currentUserInfo?.username || 'not_id'}
            splitNames={featureFlags.new_advisor_dashboard}
            updateOnSdkTimedout
            evaluatedComponent={<BoardsAndInvitations />}
            conditionFlag
            conditionFailedComponent={<BoardsAndInvitationsLegacy />}
          />
          
        </Grid>
      </Grid>
      <Grid
        item
        xs={12}
        md={4}
        sx={{
          width: isSM ? '100%' : null,
          display: { xxs: 'block', xs: 'none' },
          mt: '24px',
        }}
      >
        <MembershipTile />
      </Grid>
    </Box>
  );
};

export default Dashboard;
